
$(document).ready(function(){
	var url = location.protocol + "//" + location.host + location.pathname;
	$("a[href='"+url+"']").addClass('current');
	$("a[href='"+ url.replace(/\/$/, "") +"']").addClass('current');

	var path = location.pathname;
	$("a[href='"+path+"']").addClass('current');
	$("a[href='"+ path.replace(/\/$/, "") +"']").addClass('current');

});

